import * as api from "@/api/williams/scopesOfWork";
import { getFullPath, routes } from "../../routes";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router";

export function useDeleteScope(redirect: boolean) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(async (id: string) => {
    await api.deleteScopeOfWork(id);

    queryClient.removeQueries(queryKeys.scopeOfWork.single(id));
    queryClient.invalidateQueries(queryKeys.scopeOfWork.list());

    if (redirect) {
      navigate(getFullPath(routes.scopeOfWork.list()), {
        replace: true,
        state: {
          skipSavePrompt: true,
        },
      });
    }
  });
}
